import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DataServiceService } from '../../services/data-service.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  isExpanded: boolean= false;
  isPinned : boolean=false;
  menuItems: MenuItem[] = [];
  userMenuItems: MenuItem[] = []
  toggleStatus: boolean = false

  constructor(private dataServiceService: DataServiceService, private authService: AuthService) {}

  ngOnInit() {
    this.initializeMenu()
  }

  initializeMenu() {
    this.menuItems = [
      {
        label: 'Dashboard',
        icon: 'pi pi-home',
        routerLink: ['/dispatch_dash']
      },
      {
        label: 'Orders',
        icon: 'pi pi-box',
        routerLink: ['/orders']
      },
      {
        label: 'Order Calendar',
        icon: 'pi pi-calendar',
        routerLink: ['/order-calendar']
      },
      {
        label: 'Drivers',
        icon: 'pi pi-users',
        routerLink: ['/drivers']
      },
      {
        label: 'Equipment',
        icon: 'pi pi-wrench',
        routerLink: ['/equipment']
      },
      {
        label: 'Customers',
        icon: 'pi pi-info-circle',
        routerLink: ['/customers']
      },
      {
        label: 'Manage Drivers',
        icon: 'pi pi-cog',
        routerLink: ['/manage-drivers']
      }
    ];
  }

  togglePin(event: Event) {
        event.stopPropagation();
        this.isPinned = !this.isPinned;
        this.isExpanded = this.isPinned;
      }
  
  expandMenu() {
    if (!this.isPinned) {
      this.isExpanded = true;
    }
  }

  collapseMenu() {
    if (!this.isPinned) {
      this.isExpanded = false;
    }
  }

logout() {
  this.authService.logout();
}
}